import IMask from "imask";
import "../focusOnError.js";

require('dropzone');
Dropzone.autoDiscover = false;

const form = document.getElementById('listForm');
let uploadedDocumentMap = {};

let drop = new Dropzone('#file', {
    url: media_endpoint,
    maxFilesize: 10, // MB
    acceptedFiles: ".pdf",
    addRemoveLinks: true,
    headers: {
        'X-CSRF-TOKEN': c_token,
    },
    success: function (file, response) {
        let fileData = {
            name: response.name,
            size: file.size,
        }

        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "files[]");
        input.setAttribute("data-file", response.name);
        input.setAttribute("value", JSON.stringify(fileData));
        form.appendChild(input);

        uploadedDocumentMap[file.name] = response.name;
    },
    removedfile: function (file) {

        file.previewElement.remove();
        let name;
        if (typeof file.file_name !== 'undefined') {
            name = file.file_name;
        } else {
            name = uploadedDocumentMap[file.name];
        }

        let input = form.querySelector('[data-file="' + name + '"]');
        console.log(input);
        form.removeChild(input);
    },
    init: displayOldFiles,
});

function displayOldFiles() {
    if (files)
        console.log(files);
    for (let i in files) {
        let file = JSON.parse(files[i]);

        let input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "files[]");
        input.setAttribute("data-file", file.name);
        input.setAttribute("value", files[i]);
        form.appendChild(input);
        uploadedDocumentMap[file.name] = file.name;

        this.options.addedfile.call(this, file);
        // this.options.thumbnail.call(this, file, '/storage/tmp/uploads/job_applications/' + file.name);
        // file.previewElement.classList.add('dz-success');
        file.previewElement.classList.add('dz-complete');
        // file.previewElement.querySelector('[data-dz-thumbnail]')
        //     .classList.add('w-100', 'h-100', 'object-fit');
    }
};

// Phone Number Mask
let phoneInputs = document.getElementsByClassName("phone-mask");

if (phoneInputs.length) {
    for (let input of phoneInputs) {
        let maskOptions = {
            mask: "(000) 000-0000"
        };
        IMask(input, maskOptions);
    }
}

/**
* focus on first error mesage
*/

let error = document.querySelector('.is-invalid');

if (error)
    error.focus();

if (!error) {
    let captcaErrorEl = document.querySelector('.il-captcha-error');
    if (captcaErrorEl)
        captcaErrorEl.scrollIntoView({block: "center"});
}
if (!error) {
    let captcaErrorEl = document.querySelector('.il-file-error');
    if (captcaErrorEl)
        captcaErrorEl.scrollIntoView({block: "center"});
}

